import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Home from "./components/pages/Home";
import Entries from "./components/pages/Entries";
import AddEntry from "./components/pages/AddEntry";
import EditEntry from "./components/pages/EditEntry";
import Images from "./components/pages/Images";
import Logout from "./components/pages/Logout";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path={process.env.REACT_APP_DOBLOG_BACKEND_PATH} component={Home} exact />
        <Route path={process.env.REACT_APP_DOBLOG_BACKEND_PATH + "entries"} component={Entries} exact />
        <Route path={process.env.REACT_APP_DOBLOG_BACKEND_PATH + "entries/add"} component={AddEntry} exact />
        <Route path={process.env.REACT_APP_DOBLOG_BACKEND_PATH + "entries/edit/:entryId"} component={EditEntry} exact />
        <Route path={process.env.REACT_APP_DOBLOG_BACKEND_PATH + "images"} component={Images} exact />
        <Route path={process.env.REACT_APP_DOBLOG_BACKEND_PATH + "logout"} component={Logout} exact />
      </Switch>
    </Router>
  )
}

export default App;